var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_357",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10449",
    "data-name": "Group 10449",
    transform: "translate(9 5.704)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -5.7)",
    filter: "url(#Ellipse_357)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_357-2",
    "data-name": "Ellipse 357",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10273",
    "data-name": "Group 10273",
    transform: "translate(18.031 16.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44385",
    "data-name": "Path 44385",
    d: "M28.863,53.9H25.071a1.4,1.4,0,0,0-.294-.088,26.773,26.773,0,0,1-9.092-2.361,1.309,1.309,0,0,0-.607-.113,16.968,16.968,0,0,0-1.982.21q-4.067.785-8.122,1.628c-.93.194-1.842.481-2.762.725H1.264a5.9,5.9,0,0,1-.775-.518.8.8,0,0,1-.209-.5,3.751,3.751,0,0,1,.957-2.928,16.248,16.248,0,0,0,1.78-2.535c.7-1.168,1.322-2.385,1.97-3.585a1.3,1.3,0,0,0-.162-1.527A25.809,25.809,0,0,1,.421,31.68c-.163-.944-.282-1.9-.421-2.845V25.043c.044-.328.092-.655.131-.983A25.693,25.693,0,0,1,5.169,11.093C11.982,2.227,21.006-1.376,32.013.471A25.5,25.5,0,0,1,48.494,10.713,26.355,26.355,0,0,1,53.68,30.682a25.664,25.664,0,0,1-4.956,12.181A26.6,26.6,0,0,1,31.712,53.48c-.943.174-1.9.282-2.849.421M5.807,49.476a2.216,2.216,0,0,0,.244-.015c2.494-.469,4.984-.962,7.484-1.4a6.716,6.716,0,0,1,4.042.483,22.686,22.686,0,0,0,14.089,1.5A22.848,22.848,0,0,0,44.836,42.3a23.034,23.034,0,0,0,5.48-18.631,22.081,22.081,0,0,0-5.611-12.238c-6.052-6.656-13.578-9.208-22.419-7.58A22.19,22.19,0,0,0,9.078,11.6,23.091,23.091,0,0,0,3.852,31.587a22.339,22.339,0,0,0,4.1,9.3,3.108,3.108,0,0,1,.585,2.777,14.979,14.979,0,0,1-.922,2.558c-.532,1.1-1.183,2.141-1.811,3.26",
    transform: "translate(0 0)",
    fill: "#1a1818",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44386",
    "data-name": "Path 44386",
    d: "M140.122,113.634c0,1.254,0,2.481,0,3.707a1.688,1.688,0,1,1-3.366-.006q0-2.316,0-4.632a2.271,2.271,0,0,1,2.414-2.457,5.871,5.871,0,0,0,4.483-9.845,4.766,4.766,0,0,0-5.34-1.1,4.9,4.9,0,0,0-3.237,4.512c-.018.227-.007.456-.01.684a1.659,1.659,0,0,1-1.677,1.712,1.685,1.685,0,0,1-1.694-1.7,8.435,8.435,0,0,1,16.76-1.779,9.28,9.28,0,0,1-7.03,10.672c-.406.1-.822.149-1.3.234",
    transform: "translate(-113.158 -82.105)",
    fill: "#1a1818",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44387",
    "data-name": "Path 44387",
    d: "M169.411,275.327a1.683,1.683,0,1,1-1.682,1.656,1.666,1.666,0,0,1,1.682-1.656",
    transform: "translate(-144.129 -236.59)",
    fill: "#1a1818",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.4c2c743505bada289055c580fdd14fda.svg";
export { ForwardRef as ReactComponent };